<template>
  <b-modal
      modal-class="overdue-modal"
      v-model="showModal"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      hide-header-close
      no-close-on-esc
      no-enforce-focus
  >
    <div v-if="overdueData">
      <p class="final" v-if="overdueData.overdue_days >= 10"><span>FINAL CALL</span></p>
      <h3>{{resourceTitle}}: License Payment Overdue by {{overdueData.overdue_days}} days</h3>
      <p class="bold-txt">Please make sure Wallkit software license payments are submitted within agreed due dates.</p>
      <p>Please note: payments overdue by over 5 calendar days may be a subject to automatic payment withdrawal and administrative fees applied.</p>
      <b-btn variant="primary" @click="goToInvoices">
        {{ $t('billing.view_invoices') }}
      </b-btn>
      <p class="bold-txt">If you experience any issues with settling the bill, please reach out to <a class="mail" href="mailto:billing@wallkit.net">billing@wallkit.net</a> as soon as possible.</p>
      <b-button class="px-4" variant="outline-primary" @click="showModal = false">
        {{ $t('billing.view_dashboard') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'OverdueNotice',
  data() {
    return {
      showModal: false,
      overdueData: null,
      resourceTitle: '',
    };
  },
  computed: {
    isAuthorized() {
      return this.$store.getters['auth/isAuthorized'];
    },
  },
  created() {
    // console.log('OverdueNotice created, fetching status...');
    if (this.isAuthorized) {
      this.fetchOverdueStatus();
    }
  },
  methods: {
    fetchOverdueStatus() {
      // console.log('Fetching overdue status from API...');

      if (localStorage.getItem('skipModalOnce') && this.overdueData && this.overdueData.overdue_days >= 10) {
        // console.log('Skipping modal once due to skipModalOnce flag and overdue_days >= 10');
        localStorage.removeItem('skipModalOnce');
        return;
      }

      this.getData('resources/pricing/invoice/overdue')
          .then(({ data }) => {
            // console.log('API response:', data);


            // data.item = data.item || { id: null, is_overdue: true, overdue_days: 0 };
            // const simulatedOverdueDays = 4;
            // const simulatedToday = '2025-06-13';
            // data.item.overdue_days = simulatedOverdueDays;
            // data.item.is_overdue = simulatedOverdueDays > 0;
            // console.log('Simulated overdue_days:', simulatedOverdueDays);
            // console.log('Simulated today:', simulatedToday);

            if (data.item) {
              this.overdueData = data.item;
              // console.log('Overdue days:', data.item.overdue_days);
              // console.log('Is overdue:', data.item.is_overdue);

              const currentResource = this.$store.getters['resource/currentResource'];
              // console.log('Current resource from Vuex:', currentResource);
              this.resourceTitle = currentResource && currentResource.title ? currentResource.title : 'Unknown Resource';
              // console.log('Resource title:', this.resourceTitle);

              const lastShownDate = localStorage.getItem('modalLastShownDate');
              const today = new Date().toISOString().split('T')[0];
              if (lastShownDate === today && data.item.overdue_days >= 2 && data.item.overdue_days < 10) {
                // console.log('Modal already shown today for 2 <= overdue_days < 10');
                this.showModal = false;
                return;
              }

              if (data.item.overdue_days >= 10) {
                // console.log('Showing modal: overdue_days >= 10');
                this.showModal = true;
              } else if (data.item.overdue_days >= 2) {
                // console.log('Showing modal once per day: 2 <= overdue_days < 10');
                this.showModal = true;
                localStorage.setItem('modalLastShownDate', today);
              } else {
                // console.log('Not showing modal: overdue_days < 2');
                this.showModal = false;
              }
            } else {
              // console.log('No item in API response');
              this.showModal = false;
            }
          })
          .catch(error => {
            console.log('get overdue status error', error);
            this.$noty.error('Failed to fetch overdue status');
          })
          .finally(() => {
            // console.log('Fetch overdue status completed');
          });
    },
    goToInvoices() {
      this.showModal = false;
      if (this.overdueData && this.overdueData.overdue_days >= 10) {
        // console.log('Setting skipModalOnce flag for overdue_days >= 10');
        localStorage.setItem('skipModalOnce', 'true');
      }
      if (this.$route.path !== '/billing-info') {
        this.$router.push({ name: 'Billing' });
      }
    },
  },
  watch: {
    '$route'() {
      // console.log('Route changed, refetching overdue status...');
      this.fetchOverdueStatus();
    },
  },
};
</script>

<style scoped>

</style>